import { style } from '@vanilla-extract/css'
import { vars } from '../../../../styles/theme.css'

export const wrapper = style({
  gridColumn: '1 / -1',
  display: 'grid',
  gridTemplateColumns: 'subgrid',
  position: 'relative',
  padding: '10px 21px',
  background: vars.color.drawBackgroundLighter,
  borderRadius: vars.blocks.radius,
  color: vars.color.dark,
  textDecoration: 'none',
  fontWeight: vars.font.smallNormal.weight,
  fontSize: vars.font.smallNormal.size,
  transition: 'background 0.2s',
  gap: 16
})

export const wrapperDisabled = style({})

/** Compact card: tighter padding, subtitle stacked under the title, smaller type. */
export const wrapperCompact = style({
  padding: '8px 14px',
  gap: 12
})

export const wrapWithHover = style({
  cursor: 'pointer',
  selectors: {
    '&:hover': {
      background: vars.color.mediumLighter
    }
  }
})

export const activeCard = style({
  backgroundColor: vars.color.mediumLighter,
  selectors: {
    '&:hover': {
      background: vars.color.mediumLighter
    }
  }
})

export const iconStyle = style({
  position: 'relative',
  width: '40px',
  height: '40px',
  aspectRatio: '1/1',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: vars.color.darkLighter,
  color: vars.color.white,
  flexShrink: 0,
  fontWeight: vars.font.subcontent.weight,
  cursor: 'default'
})

export const wrapHeader = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  minWidth: 0
})

export const wrapHeaderWithIcon = style({
  flex: 2
})

export const wrapTitle = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '4px 13px'
})

export const wrapTitleCompact = style({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 2,
  minWidth: 0
})

export const titleStyle = style({
  fontSize: vars.font.h3.size,
  fontWeight: vars.font.h3.weight,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline-flex',
  color: vars.color.dark,
  textDecoration: 'none',
  gap: 8
})

export const titleWithHover = style({
  selectors: {
    '&:hover': {
      color: vars.color.darkLighter,
      textDecoration: 'underline'
    }
  }
})

export const titleWithoutSubtitle = style({
  fontSize: vars.font.content.size,
  fontWeight: vars.font.content.weight
})

export const titleCompact = style({
  fontSize: vars.font.content.size,
  fontWeight: vars.font.smallBold.weight,
  maxWidth: '100%'
})

export const subTitleStyle = style({
  fontSize: vars.font.body.size,
  fontWeight: 400,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0
})

export const subTitleCompact = style({
  fontSize: vars.font.subcontent.size,
  fontWeight: vars.font.subcontent.weight,
  color: vars.color.mediumDarker,
  maxWidth: '100%'
})

export const contentStyle = style({
  display: 'flex',
  gap: 10,
  flexWrap: 'wrap',
  minWidth: 0
})

export const metaItem = style({
  color: vars.color.dark,
  fontSize: vars.font.smallNormal.size,
  fontWeight: vars.font.smallNormal.weight,
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  whiteSpace: 'nowrap',
  justifyContent: 'center',
  minWidth: 0,
  selectors: {
    [`${wrapperDisabled} &`]: {
      opacity: 0.5
    }
  }
})

export const metaItemRight = style({
  alignItems: 'flex-end'
})

export const metaItemContent = style({
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis'
})

export const metaItemTitle = style({
  fontSize: vars.font.smallBold.size,
  fontWeight: vars.font.smallBold.weight,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0
})
